import { render } from "./HoplomachusVictorumView.vue?vue&type=template&id=0bf8490b"
import script from "./HoplomachusVictorumView.vue?vue&type=script&lang=js"
export * from "./HoplomachusVictorumView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__